import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import Joi from 'joi'
import { joiResolver } from '@hookform/resolvers/joi'
import { loginUser } from '../../redux/slices'
import { DefaultState } from '../../types'
import ICSTextInput from '../../components/ICSTextInput/ICSTextInput'
import ICSButton from '../../components/ICS/Button/ICSButton'
import ICSErrorCard from '../../components/ICSErrorCard/ICSErrorCard'
import {
  Col,
  Row,
  Form,
  FormGroup
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { LoadIndicator } from 'devextreme-react'

const defaultJoiSchema = {
  username: Joi.string().required().messages({
    'any.required': `Username is required`,
  }),
  password: Joi.string().required().messages({
    'any.required': `Password is required`,
  }),
}

const schema = Joi.object(defaultJoiSchema)

const LoginForm = () => {
  const {
    formState: { errors, isValid },
    handleSubmit,
    control,
    setError,
    getValues,
  } = useForm({
    mode: 'onChange',
    resolver: joiResolver(schema),
  })
  const dispatch = useDispatch()
  const { loading, error, passwordExpired } = useSelector((state: DefaultState) => state.session)
  const { allow_lost_password } = useSelector(
    (state: DefaultState) => state.strategies
  )

  const onSubmit = useCallback(() => {
    const { username, password } = getValues()
    dispatch(loginUser({ username, password }))
  }, [])

  useEffect(() => {
    if (error && error.code == 'invalid' && error.fields.length > 0) {
      error.fields.forEach(e => {
        setError(e.field, { message: e.message })
      })
    }

    if(passwordExpired) {
      window.location.replace('/ui/#!/account/passwordChange')
    }
  }, [error])

  if(passwordExpired) {
    return <LoadIndicator />
  }

  return (
    <>
        {error?.code && <ICSErrorCard
          code={error?.code ? error.code : 'error'}
          message={error?.message ? error.message : ''}
          fields={error?.fields ? error.fields : []}
          title={error?.message == 'Password is expired' ? 'Your password has expired' : 'Login failed'}
        />}
      <Row>
        <Col xs={{ size: 12 }}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <Row>
                <Col id='username_col'>
                  <ICSTextInput
                    label='Username'
                    name='username'
                    // helpText='Login username'
                    isSubmitted
                    errors={errors}
                    control={control}
                    setError={setError}
                    id='username-input'
                  />
                </Col>
              </Row>
              <Row>
                <Col id='password_col'>
                  <ICSTextInput
                    label='Password'
                    name='password'
                    // helpText={'Password. Click below to reset.'}
                    isSubmitted
                    errors={errors}
                    control={control}
                    setError={setError}
                    isPassword={true}
                    id='password-input'
                  />
                  {allow_lost_password && (<Link to='/ui2/lostpassword'>Forgot password? </Link> )}
                </Col>
              </Row>
                  <ICSButton
                    id='form_submit'
                    width={60}
                    useSubmitBehavior={true}
                    type='success'
                    disabled={!isValid || error?.code === 'error' || loading}
                  >
                    Login
                  </ICSButton>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </>
  )
}

export default LoginForm